import * as React from 'react';
import { useContext } from 'react';

import { PlagiarismDetectionContextProvider } from 'bundles/academic-integrity/components/plagiarism-detection/PlagiarismDetectionContext';
import ContentPanelContainer from 'bundles/grading/components/layout/ContentPanelContainer';
import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';
import LinearNav from 'bundles/grading/components/staff-graded-assignments/linear-nav/LinearNav';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import SGAMiddlePanel from 'bundles/grading/components/staff-graded-assignments/middle-panel/SGAMiddlePanel';
import NotificationsGlobal from 'bundles/grading/components/staff-graded-assignments/notifications/NotificationsGlobal';
import SGARightPanel from 'bundles/grading/components/staff-graded-assignments/right-panel/SGARightPanel';

// container for SGA content panel related components
const SGAContentPanel = () => {
  const { submissionData } = useContext(SGAPageContext);
  const { submitter } = submissionData.data || {};
  return (
    <PlagiarismDetectionContextProvider>
      <ContentPanelContainer
        middlePanelComponent={<SGAMiddlePanel />}
        // when the submitter has no submissions, we don't want to render the right panel for SGA
        rightPanelComponent={submitter?.submitterId && <SGARightPanel />}
        navigationComponent={<LinearNav />}
        globalNotificationsComponent={<NotificationsGlobal />}
      />
    </PlagiarismDetectionContextProvider>
  );
};

export default SGAContentPanel;
